export type HeightBand = 'u160' | '160-169' | '170-179' | '180-189' | 'o190';

export interface FitProfile {
  heightBand: HeightBand | null;
  knee: 0 | 1 | 2 | 3 | null;
  neckBack: 0 | 1 | 2 | 3 | null;
  soundLight: 0 | 1 | 2 | 3 | null;
  mobilityNeed: boolean | null;
}

export interface FitObservation {
  contributorRef: string | null;
  heightBand: HeightBand | null;
  knee: 0 | 1 | 2 | 3 | null;
  neckBack: 0 | 1 | 2 | 3 | null;
}

const heightBands: readonly HeightBand[] = ['u160', '160-169', '170-179', '180-189', 'o190'];

export function bandDistance(left: HeightBand | null, right: HeightBand | null): number | null {
  if (left === null || right === null) return null;
  return Math.abs(heightBands.indexOf(left) - heightBands.indexOf(right));
}

export function fitCohort(profile: FitProfile, rows: FitObservation[]) {
  if (profile.heightBand === null) {
    return { matchedN: 0, uncomfortableN: 0, ratioAllowed: false, statement: '내 조건을 넣으면 비슷한 체형의 기록만 볼 수 있어요.' };
  }
  const byContributor = new Map<string, FitObservation>();
  for (const row of rows) {
    const contributorRef = row.contributorRef?.trim();
    if (!contributorRef || byContributor.has(contributorRef)) continue;
    const distance = bandDistance(profile.heightBand, row.heightBand);
    if (distance !== null && distance <= 1) byContributor.set(contributorRef, row);
  }
  const cohort = [...byContributor.values()];
  if (cohort.length === 0) return { matchedN: 0, uncomfortableN: 0, ratioAllowed: false, statement: '내 조건과 비슷한 사람의 기록이 아직 없어요.' };
  const uncomfortable = cohort.filter((row) => (row.knee ?? 0) >= 2).length;
  if (cohort.length < 3) return { matchedN: cohort.length, uncomfortableN: uncomfortable, ratioAllowed: false, statement: `내 조건과 비슷한 기록 ${cohort.length}명이 있어요. 표본이 적어 비율은 만들지 않아요.` };
  return { matchedN: cohort.length, uncomfortableN: uncomfortable, ratioAllowed: true, statement: `내 조건과 비슷한 ${cohort.length}명 중 ${uncomfortable}명이 무릎 불편을 남겼어요.` };
}

export function fitStatement(profile: FitProfile, rows: FitObservation[]): string {
  return fitCohort(profile, rows).statement;
}
